<template>
  <div class="container">
    <p>{{ text }}</p>
    <div class="span-text">
      <span>{{ textOne }}</span>
      <span>{{ textTwo }}</span>
      <span>{{ textTrhee }}</span>
      <span>{{ textFor }}</span>
    </div>

    <br />
    <p>{{ textFive }}</p>
    <Enlaces />
  </div>
</template>

<script>
import Enlaces from "./Enlaces";
export default {
  components: {
    Enlaces,
  },
  data() {
    return {
      text: "Los principales aspectos que comprenden este balance son:",
      textOne:
        "1. Presentación de las definiciones estratégicas y de los resultados mas relevantes de la institución,",
      textTwo:
        "2. Identificación de la institución en aspecto como; estructura organizacional, dotación, principales estructuras,",
      textTrhee:
        "3. Resultados de la gestión incluyendo informe de desempeño, de gestión financiera, de recursos humanos,",
      textFor: "4. Desafios para el año siguiente, entre otro aspectos.",
      textFive: 
        "Como parte del equipo responsable de la Declaración del Balance de Gestión Integral, a continuación te facilitamos el acceso a los documentos que puedes descargar",
    };
  },
};
</script>

<style scoped>
.span-text {
  display: grid;
}

span {
  font-size: 10px;
}

p {
  font-size: 14px;
}
</style>
